import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Link, useHistory } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';
import PublicEventsContext from './PublicEventsContext';

// Components
import EventDetails from './EventDetails';
import EventMeta from './EventMeta';

import styles from './PublicEvents.module.postcss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

function LocationEvent({ event, forCalendar = false }) {
  const { name: eventName, bookings } = event;
  const history = useHistory();
  const { imageBase } = useContext(ConfigContext);
  const { location } = useContext(PublicEventsContext);

  if (!bookings || bookings.length === 0) {
    return null;
  }

  // The whole page is one location, so its name and address don't repeat on
  // every card. display_name falls back to the pod/location name; only an
  // occurrence with its own name (a one-off market night) says something new.
  const namedEvent = eventName && eventName.trim() && eventName.trim() !== location?.name?.trim()
    ? eventName.trim()
    : null;

  let displayedBookings = bookings.map((booking) => {
    const { truck } = booking;
    const image = truck.featured_photo ? `${imageBase}/${truck.featured_photo}` : '/static/images/truck-placeholder.png';

    return (
      <div className={styles.LocationEvent_Truck} key={booking.id}>
        <Link to={`/food-trucks/${truck.id}`} target="_blank" rel="noopener noreferrer">
          <img
            className={styles.LocationEvent_Image}
            src={image}
            alt={truck.name}
            loading='lazy'
          />

          <div className={styles.LocationEvent_Content}>
            <h3 className='u-mb05'>{truck.name}</h3>
            { truck.food_categories_string &&
              <div className={styles.LocationEvent_Categories + ' u-mb05'}>{truck.food_categories_string}</div>
            }
            { namedEvent &&
              <div className={styles.LocationEvent_EventName + ' u-mb05'}>{namedEvent}</div>
            }
            <EventDetails
              className={styles.LocationEvent_Details}
              event={event}
              showBadges
              vehicleType={truck.vehicle_type}
              establishedYear={truck.established_year}
            />
          </div>

          <div className={styles.LocationEvent_Menu}>
            <button
              type='button'
              className='Button Button--outlined'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                history.push(`/food-trucks/${truck.id}#menu`);
              }}
            >
              View menu
            </button>
          </div>
        </Link>
      </div>
    );
  });

  displayedBookings = displayedBookings.filter((booking) => {
    return booking !== undefined || booking !== null;
  });

  return (
    <div className={cn(styles.LocationEvent, { [styles.LocationEvent__calendar]: forCalendar })}>
      {displayedBookings}
      <EventMeta event={event} location={location} />
    </div>
  );
}

LocationEvent.propTypes = {
  event: PropTypes.object.isRequired,
};

export default LocationEvent;
